import axios from 'axios'

import { localStorageSet } from '@scouts/helpers'

import {
    ERROR_MESSAGE_SAVING,
    PATH_QUARTERLY_TAX_RETURN_LEGACY,
    TAX_RETURN_STATUS_UPLOADING_DOCUMENTS,
} from '../constants'
import { getAppUrl } from '../helpers/url-domain'
import { QUARTERLY_TAX_RETURNS } from '../store/action-types'
import { createQuarterlyTaxReturn } from '../store/quarterly-tax-returns/actions'
import { track, TRACK_QUARTERLY_TAX_RETURN_START } from '../trackers'
import { handleRequestError } from './request'

export const ASSIGN_QUARTERLY_TAX_RETURN_ACCOUNTANT = 'ASSIGN_QUARTERLY_TAX_RETURN_ACCOUNTANT'

export const REQUEST_QUARTERLY_TAX_RETURN = 'REQUEST_QUARTERLY_TAX_RETURN'
export const SAVE_QUARTERLY_TAX_RETURN = 'SAVE_QUARTERLY_TAX_RETURN'
export const SAVE_QUARTERLY_TAX_RETURN_STATUS = 'SAVE_QUARTERLY_TAX_RETURN_STATUS'
export const UPDATE_AND_SAVE_QUARTERLY_TAX_RETURN = 'UPDATE_AND_SAVE_QUARTERLY_TAX_RETURN'
export const UPDATE_AND_SAVE_QUARTERLY_TAX_RETURN_STATUS = 'UPDATE_AND_SAVE_QUARTERLY_TAX_RETURN_STATUS'
export const UPDATE_QUARTERLY_TAX_RETURN_STATUS = 'UPDATE_QUARTERLY_TAX_RETURN_STATUS'
export const REQUEST_QUARTERLY_TAX_RETURN_BOOK = 'REQUEST_QUARTERLY_TAX_RETURN_BOOK'
export const RECEIVE_QUARTERLY_TAX_RETURN_BOOK = 'RECEIVE_QUARTERLY_TAX_RETURN_BOOK'
export const REQUEST_QUARTERLY_TAX_RETURN_PAYMENTS = 'REQUEST_QUARTERLY_TAX_RETURN_PAYMENTS'
export const RECEIVE_QUARTERLY_TAX_RETURN_PAYMENTS = 'RECEIVE_QUARTERLY_TAX_RETURN_PAYMENTS'
export const REQUEST_QUARTERLY_TAX_RETURN_PAYMENT_INVOICE = 'REQUEST_QUARTERLY_TAX_RETURN_PAYMENT_INVOICE'
export const RECEIVE_QUARTERLY_TAX_RETURN_PAYMENT_INVOICE = 'RECEIVE_QUARTERLY_TAX_RETURN_PAYMENT_INVOICE'

export const createQuarterlyTaxReturnAndActivateLegacy = (data) => (dispatch) => {
    dispatch({ type: QUARTERLY_TAX_RETURNS.CREATE_AND_ACTIVATE_QUARTERLY_TAX_RETURN, data })

    const { taxYear, quarter } = data

    return dispatch(createQuarterlyTaxReturn({ taxYear, quarter }))
        .then(({ id: quarterlyTaxReturnId }) => {
            track(TRACK_QUARTERLY_TAX_RETURN_START, { taxYear, quarter })
            return dispatch(
                saveQuarterlyTaxReturnStatus({ quarterlyTaxReturnId, status: TAX_RETURN_STATUS_UPLOADING_DOCUMENTS })
            )
        })
        .then(({ id: quarterlyTaxReturnId }) => {
            setTimeout(() => {
                dispatch(activateQuarterlyTaxReturnLegacy({ quarterlyTaxReturnId }))
            }, 1000)
        })
}

export const activateQuarterlyTaxReturnLegacy = (data) => (dispatch) => {
    dispatch({ type: QUARTERLY_TAX_RETURNS.ACTIVATE_QUARTERLY_TAX_RETURN, data })

    const { quarterlyTaxReturnId } = data

    localStorageSet('quarterlyTaxReturnId', quarterlyTaxReturnId)
    window.location.assign(getAppUrl(PATH_QUARTERLY_TAX_RETURN_LEGACY))
}

export const requestQuarterlyTaxReturn = (id) => (dispatch) => {
    dispatch({ type: REQUEST_QUARTERLY_TAX_RETURN, data: { id } })

    axios
        .get(`/quarterlytaxreturns/${id}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveQuarterlyTaxReturn({ ...responseData, fetchSuccessful: true }))
            return responseData
        })
        .catch((error) => {
            dispatch(receiveQuarterlyTaxReturn({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveQuarterlyTaxReturn = (data) => ({ type: QUARTERLY_TAX_RETURNS.RECEIVE_QUARTERLY_TAX_RETURN, data })

export const requestQuarterlyTaxReturnPayments = (quarterlyTaxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_QUARTERLY_TAX_RETURN_PAYMENTS })

    return axios
        .get(`/quarterlytaxreturns/${quarterlyTaxReturnId}/payments`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveQuarterlyTaxReturnPayments({ payments: responseData }))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const receiveQuarterlyTaxReturnPayments = (data) => ({ type: RECEIVE_QUARTERLY_TAX_RETURN_PAYMENTS, data })

export const requestQuarterlyTaxReturnPaymentInvoice = (data) => (dispatch) => {
    dispatch({ type: REQUEST_QUARTERLY_TAX_RETURN_PAYMENT_INVOICE, data })

    const { paymentId } = data

    return axios
        .get(`payments/${paymentId}/downloadinvoice`)
        .then((response) => {
            const responseData = response?.data || ''
            dispatch(receiveQuarterlyTaxReturnPaymentInvoice({ invoiceDownloadUrl: responseData, paymentId }))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

const receiveQuarterlyTaxReturnPaymentInvoice = (data) => ({
    type: RECEIVE_QUARTERLY_TAX_RETURN_PAYMENT_INVOICE,
    data,
})

export const updateAndSaveQuarterlyTaxReturn = (data) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_QUARTERLY_TAX_RETURN, data })

    dispatch(receiveQuarterlyTaxReturn(data))

    return dispatch(saveQuarterlyTaxReturn())
}

export const saveQuarterlyTaxReturn = () => (dispatch, getState) => {
    dispatch({ type: SAVE_QUARTERLY_TAX_RETURN })

    const { quarterlyTaxReturn } = getState()

    const { id: quarterlyTaxReturnId } = quarterlyTaxReturn

    return axios
        .put(`/quarterlytaxreturns/${quarterlyTaxReturnId}`, quarterlyTaxReturn)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveQuarterlyTaxReturn(responseData))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const saveQuarterlyTaxReturnStatus = (data) => (dispatch) => {
    dispatch({ type: SAVE_QUARTERLY_TAX_RETURN_STATUS, data })

    const { quarterlyTaxReturnId, status } = data

    return axios
        .put(`/quarterlytaxreturns/${quarterlyTaxReturnId}/status/${status}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveQuarterlyTaxReturn(responseData))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

const receiveQuarterlyTaxReturnBook = (data) => ({ type: RECEIVE_QUARTERLY_TAX_RETURN_BOOK, data })

export const requestQuarterlyTaxReturnBook = (quarterlyTaxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_QUARTERLY_TAX_RETURN_BOOK })

    return axios
        .get(`/quarterlytaxreturns/${quarterlyTaxReturnId}/books`, {
            responseType: 'arraybuffer',
        })
        .then((response) => {
            const book = response?.data || {}
            dispatch(receiveQuarterlyTaxReturnBook({ book }))
            return book
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}
